import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import {
  assignQuiz,
  editLesson,
  editQuiz,
  getLessonById,
  getQuiz,
  getVideo,
} from "../../../../redux/educator/actions";
import { StateType } from "../../../../utils/types";
import {
  selectLesson,
  selectQuizzes,
  selectLessonLoading,
  selectQuizzesLoading,
  selectVideos,
  selectAlertsLoading,
  selectLessonSubmitLoading,
} from "../../../../redux/educator/selector";
import { setInitialSteps } from "../../../../redux/shared/actions";

const mapStateToProps = (state: StateType) => ({
  lesson: selectLesson(state),
  quizzes: selectQuizzes(state),
  lessonLoading: selectLessonLoading(state),
  quizzesLoading: selectQuizzesLoading(state),
  videos: selectVideos(state),
  videosLoading: selectAlertsLoading(state),
  submitLoading: selectLessonSubmitLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getLessonById,
      setInitialSteps,
      assignQuiz,
      getQuiz,
      editLesson,
      editQuiz,
      getVideo,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
